"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VariableResolver = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _path = require("./path");
class VariableResolver {
  constructor() {
    (0, _defineProperty2.default)(this, "type", "var");
  }
  resolve(context, param) {
    let {
      value,
      path
    } = this.resolveReference(context, param);
    return {
      value: value === null || value === void 0 ? void 0 : value.value(),
      path
    };
  }
  resolveReference(context, param) {
    let ctx = context;
    if (param.ctx) {
      ctx = context.findContext(param.ctx);
    }
    let value;
    let path;
    if ("name" in param) {
      var _ctx;
      let parsed = (0, _path.parseReferencePath)(param.name);
      value = (_ctx = ctx) === null || _ctx === void 0 ? void 0 : _ctx.findVariableByName(parsed.name);
      path = parsed.path;
    } else {
      var _ctx2;
      value = (_ctx2 = ctx) === null || _ctx2 === void 0 ? void 0 : _ctx2.findVariableByType(param.type);
    }
    return {
      value,
      path
    };
  }
}
exports.VariableResolver = VariableResolver;
//# sourceMappingURL=VariableResolver.js.map